module.exports = __webpack_public_path__ + "static/media/tb-blent.11fc2108.jpeg";